import { Component, Input, OnInit } from '@angular/core';
import { IProcessEventMetadata, ISystemEvent } from 'src/app/shared/interfaces/system-event.interface';
import * as _ from 'lodash';
import { ProcessEventService } from 'src/app/modules/instance/services/process-event.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    standalone: false,
    selector: 'tr[app-process-event-row]',
    templateUrl: './process-event-row.component.html',
    styleUrls: ['./process-event-row.component.scss']
})
export class ProcessEventRowComponent implements OnInit {
    @Input()
    event: ISystemEvent<IProcessEventMetadata>;

    @Input()
    index: number;

    @Input()
    showParentType: boolean = false;

    userName: string;
    details: string;

    constructor(private clipboard: Clipboard) {}

    ngOnInit(): void {
        const userFullName = _.get(this.event, 'MetaData.userFullName');
        const userEmail = _.get(this.event, 'MetaData.userEmail');
        this.userName =
            userFullName && userEmail
                ? `${userFullName} (${userEmail})`
                : userFullName
                ? userFullName
                : userEmail || '';
        this.details = ProcessEventService.getMetadataStr(this.event);
    }

    copyMetadata(): void {
        if (!this.event || !this.event.MetaData) {
            return;
        }
        const metadata = JSON.stringify(this.event.MetaData, null, 2);
        this.clipboard.copy(metadata);
    }
}
